<div *ngIf="isManageOwnerModalOpen" class="overlay">
  <div class="job-card-modal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="heading-container">
      <p class="heading-title">Owner/Facility Modal - Information</p>
      <a href="#" (click)="handleClose(); $event.preventDefault()"
        ><img style="height: 12px; width: 12px" src="/assets/images/icon/close_white.svg"
      /></a>
    </div>
    <div class="grid-container">
      <div class="item2">
        <div class="profile-section">
          <div>
            <h3>
              {{ selectedRow?.potentialJobDetail?.owner.name.trim() }} |
              {{ selectedRow?.potentialJobDetail?.facility.name.trim() }}
            </h3>
            <p>
              <i class="fa fa-map-marker-alt" style="font-size: 15px; color: #bebebe"></i>
              {{ selectedRow?.potentialJobDetail?.facility.street_address.trim() }},
              {{ selectedRow?.potentialJobDetail?.facility.city.trim() }},
              {{ selectedRow?.potentialJobDetail?.facility?.facilityState.abbreviation }},
              {{ selectedRow?.potentialJobDetail?.facility.zipcode }}
            </p>
          </div>
        </div>
      </div>
      <div class="item3">
        <div class="profile-section">
          <div>
            <p>Avg. Crew Cost:</p>
            <h3>$</h3>
          </div>
        </div>
      </div>
      <div class="item4">
        <div class="profile-section">
          <div>
            <p>Project End Date:</p>
            <h3></h3>
          </div>
        </div>
      </div>

      <div class="item5 p-0">
        <nav class="navbar navbar-expand-lg">
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse jobs-tab" id="navbarNav">
            <ul class="nav nav-tabs line-tab">
              <li class="nav-item" role="presentation">
                <a
                  class="nav-link show active"
                  id="informationTab"
                  #informationTab
                  data-toggle="tab"
                  href="#information-info"
                  role="tab"
                  aria-selected="true">
                  Information
                </a>
              </li>
              <li class="nav-item" role="presentation">
                <a class="nav-link" data-toggle="tab" href="#certifications" role="tab" aria-selected="false">
                  Certifications
                </a>
              </li>
              <li class="nav-item" role="presentation">
                <a class="nav-link" data-toggle="tab" href="#employees" role="tab" aria-selected="false">
                  Employees (4)
                </a>
              </li>
              <li class="nav-item" role="presentation">
                <a class="nav-link" data-toggle="tab" href="#jobs" role="tab" aria-selected="false"> Jobs (3) </a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
    <div class="h-100 modal-container">
      <div class="row">
        <div class="col-12">
          <div class="tab-content body-content-scroll scrollbar">
            <!-- INFORMATION Info -->
            <div class="tab-pane show active" id="information-info" role="tabpanel">
              <div class="card mt-1 border-white">
                <div class="card-body mt-3 mb-5">
                  <fieldset>
                    <div class="row">
                      <!-- LEFT COLUMN -->
                      <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                        <div class="row">
                          <div class="col-12 col-sm-2 col-md-2 col-lg-2"></div>
                          <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                            <div class="form-group text-left">
                              <label>Alias:</label>
                            </div>
                          </div>
                          <div class="col-12 col-sm-3 col-md-3 col-lg-3"></div>
                          <div class="col-12 col-sm-2 col-md-2 col-lg-2"></div>
                          <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                            <div class="form-group">
                              <div class="input-group mb-3">
                                <input
                                  [(ngModel)]="selectedRow.potentialJobDetail.jobBoardAlias"
                                  type="text"
                                  placeholder=""
                                  class="form-control"
                                  maxlength="30"
                                  #alias />
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-sm-3 col-md-3 col-lg-3"></div>

                          <div class="col-12 col-sm-2 col-md-2 col-lg-2"></div>
                          <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                            <div class="form-group">
                              <label>Site Local:</label>
                              <p class="text-dark">123455, SM 85, 357, INS, 174, 190</p>
                            </div>
                          </div>
                          <div class="col-12 col-sm-3 col-md-3 col-lg-3"></div>

                          <div class="col-12 col-sm-2 col-md-2 col-lg-2"></div>
                          <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                            <div class="form-group">
                              <label>Notes</label>
                              <textarea
                                class="form-control word_break"
                                rows="2"
                                tabindex="3"
                                #notes
                                (input)="setDataToControl('notes', notes.value)"
                                placeholder=""
                                [readonly]="isActiveWorkingStatus"></textarea>
                            </div>
                          </div>
                          <div class="col-12 col-sm-3 col-md-3 col-lg-3"></div>

                          <div class="col-12 col-sm-2 col-md-2 col-lg-2"></div>
                          <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                            <div class="form-group">
                              <label>Tags</label>
                              <textarea
                                class="form-control word_break"
                                rows="2"
                                tabindex="3"
                                #tags
                                (input)="setDataToControl('tags', tags.value)"
                                placeholder=""
                                [readonly]="isActiveWorkingStatus"></textarea>
                            </div>
                          </div>
                          <div class="col-12 col-sm-3 col-md-3 col-lg-3"></div>
                        </div>
                      </div>

                      <!-- RIGHT COLUMN -->
                      <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                        <div class="row">
                          <div class="col-12 col-sm-11 col-md-11 col-lg-11 foreman-container">
                            <app-manage-owner-list [job]="selectedRow"></app-manage-owner-list>
                          </div>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
            </div>
            <!-- INFORMATION Info End-->
            <!-- Certifications -->
            <div class="tab-pane fade" id="certifications" role="tabpanel">
              <!-- <div class="card mt-1 border-white">
                <div class="card-body mt-3 mb-5">
                  <fieldset>
                      <div>
                        <div class="d-flex mt-1">
                          <div class="flex-fill p-0">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                              <div class="row">
                                <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                                  <div class="form-group text-center">
                                    <label class="label-title">Certification/Attribute</label>
                                  </div>
                                </div>
                                <div class="col-12 col-sm-5 col-md-5 col-lg-5">
                                  <div class="form-group">
                                    <label class="label-title">Expiration Date</label>
                                  </div>
                                </div>
                              </div>

                              <div *ngFor="let attribute of jobBoardAttributesFormArray.controls | pairs"
                                [formGroupName]="getAttributeIndex(attribute)" class="row attribute-wrapper">
                                <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                                  <div class="form-group text-right">
                                    <div class="checkbox-item attribute-container">
                                      <input formControlName="status" #status type="checkbox"
                                        ([click])="setJobBoardAttribute(attribute,'status',status.checked)"
                                        [checked]="attribute.value.status" class="input-checkbox" id="aerialLifeCard">
                                      <label class="attribute-certification-text m-0"
                                        for="aerialLifeCard">{{attribute.value.name}}</label>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12 col-sm-5 col-md-5 col-lg-5">
                                  <div class="form-group attribute-container">
                                    <label class="m-0 attribute-expiration-text"></label>
                                    <div class="input-group">
                                      <input formControlName="expirationDate" id="expiration_date" type="text"
                                        class="form-control datepicker" #expiration_date placeholder="Enter Date"
                                        (mousedown)="loadDatePicker()"
                                        (focus)="setJobBoardAttribute(attribute,'expirationDate',expiration_date.value)"
                                        tabindex="121" mask="XX/XX/XXXX" [readonly]="">
                                    </div>
                                    <i class="fa fa-thin fa-pen"></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="flex-fill p-0">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                              <div class="row">
                                <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                                  <div class="form-group text-center">
                                    <label class="label-title">Certification/Attribute</label>
                                  </div>
                                </div>
                                <div class="col-12 col-sm-5 col-md-5 col-lg-5">
                                  <div class="form-group">
                                    <label class="label-title">Expiration Date</label>
                                  </div>
                                </div>
                              </div>

                              <div *ngFor="let attribute of jobBoardAttributesFormArray.controls | pairs:1"
                                [formGroupName]="getAttributeIndex(attribute)" class="row attribute-wrapper">
                                <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                                  <div class="form-group text-right">
                                    <div class="checkbox-item attribute-container">
                                      <input formControlName="status" #status type="checkbox"
                                        ([click])="setJobBoardAttribute(attribute,'status',status.checked)"
                                        [checked]="attribute.value.status" class="input-checkbox" id="aerialLifeCard">
                                      <label class="attribute-certification-text m-0"
                                        for="aerialLifeCard">{{attribute.value.name}}</label>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12 col-sm-5 col-md-5 col-lg-5">
                                  <div class="form-group attribute-container">
                                    <label class="m-0 attribute-expiration-text"></label>
                                    <div class="input-group">
                                      <input formControlName="expirationDate" id="expiration_date" type="text"
                                        class="form-control datepicker" #expiration_date placeholder="Enter Date"
                                        (mousedown)="loadDatePicker()"
                                        (focus)="setJobBoardAttribute(attribute,'expirationDate',expiration_date.value)"
                                        tabindex="121" mask="XX/XX/XXXX" [readonly]="">
                                    </div>
                                    <i class="fa fa-thin fa-pen"></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="flex-fill p-0">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                              <div class="row">
                                <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                                  <div class="form-group text-center">
                                    <label class="label-title">Certification/Attribute</label>
                                  </div>
                                </div>
                                <div class="col-12 col-sm-5 col-md-5 col-lg-5">
                                  <div class="form-group">
                                    <label class="label-title">Expiration Date</label>
                                  </div>
                                </div>
                              </div>

                              <div *ngFor="let attribute of jobBoardAttributesFormArray.controls | pairs:2"
                                [formGroupName]="getAttributeIndex(attribute)" class="row attribute-wrapper">
                                <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                                  <div class="form-group text-right">
                                    <div class="checkbox-item attribute-container">
                                      <input formControlName="status" #status type="checkbox"
                                        ([click])="setJobBoardAttribute(getAttributeIndex(attribute),'status',status.checked)"
                                        [checked]="attribute.value.status" class="input-checkbox" id="aerialLifeCard">
                                      <label class="attribute-certification-text m-0"
                                        for="aerialLifeCard">{{attribute.value.name}}</label>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12 col-sm-5 col-md-5 col-lg-5">
                                  <div class="form-group attribute-container">
                                    <label class="m-0 attribute-expiration-text"></label>
                                    <div class="input-group">
                                      <input formControlName="expirationDate" id="expiration_date" type="text"
                                        class="form-control datepicker" #expiration_date placeholder="Enter Date"
                                        (mousedown)="loadDatePicker()"
                                        (focus)="setJobBoardAttribute(attribute,'expirationDate',expiration_date.value)"
                                        tabindex="121" mask="XX/XX/XXXX" [readonly]="">
                                    </div>
                                    <i class="fa fa-thin fa-pen"></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </fieldset>
                </div>
              </div> -->
            </div>
            <!-- Certifications End -->
            <!-- EMPLOYEES -->
            <div class="tab-pane fade" id="employees" role="tabpanel">
              <div class="card mt-1 border-white table-height">
                <div class="card-body mt-3 mb-5">
                  <app-manage-employees-list></app-manage-employees-list>
                </div>
              </div>
            </div>
            <!-- EMPLOYEES End -->
            <!-- JOBS -->
            <div class="tab-pane fade" id="jobs" role="tabpanel">
              <div class="card mt-1 border-white table-height">
                <div class="card-body mt-3 mb-5">
                  <app-manage-jobs-list></app-manage-jobs-list>
                </div>
              </div>
            </div>
            <!-- JOBS End -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
